module.exports = __webpack_public_path__ + "img/pokedirectory_mockup.48956faa.jpg";